export default __webpack_public_path__ + "static/media/SPRINT.dcb2c842.png";